import axios from "axios";
import { setViewData } from "../../../Reducer/DashboardReducer";

export class ViewProductFunction {
  async UpdateProduct(
    setLoading,
    body,
    setToastConfig,
    toastConfig,
    setcraeteAppShow,
    viewData,
    setDAta,
    dispatch
  ) {
    setLoading(true);
    await axios
      .put(
        `${process.env.REACT_APP_API_URL}/api/v1/app/${viewData?.id}`,
        body,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((val) => {
        setLoading(false);
        if (val?.data?.success) {
          setDAta({
            id: val?.data?.result?.id,
            app_name: val?.data?.result?.app_name,
            app_logo: val?.data?.result?.app_logo,
            privay_policy_url: val?.data?.result?.privay_policy_url,
          });
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "success",
            message: "Updated successfully!",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              type: "success",
              message: "Updated successfully!",
            });
          }, 1800);

          dispatch(setViewData(val?.data?.result));
          setcraeteAppShow(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        if (
          err?.response?.statusText === "Unauthorized" ||
          err?.response?.status === "401"
        ) {
          localStorage.clear();
          window.location.reload();
        }
        if (!err.response) {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "error",
            message: "Network Error!",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              type: "error",
              message: "Network Error!",
            });
          }, 1800);
        }
      });
  }

  async DEleteProduct(
    setLoading,
    setToastConfig,
    toastConfig,
    viewData,
    navigation
  ) {
    setLoading(true);
    await axios
      .delete(`${process.env.REACT_APP_API_URL}/api/v1/app/${viewData?.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`,
        },
      })
      .then((val) => {
        setLoading(false);
        if (val?.data?.success) {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "success",
            message: "Deleted successfully!",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              type: "success",
              message: "Deleted successfully!",
            });
          }, 1800);

          setTimeout(() => {
            navigation("/dashboard/app-list");
          }, 1800);
        }
      })
      .catch((err) => {
        setLoading(false);
        if (
          err?.response?.statusText === "Unauthorized" ||
          err?.response?.status === "401"
        ) {
          localStorage.clear();
          window.location.reload();
        }
        if (!err.response) {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "error",
            message: "Network Error!",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              type: "error",
              message: "Network Error!",
            });
          }, 1800);
        }
      });
  }

  async ManageApp(
    setLoading,
    body,
    viewData,
    setsuccess,
    setauthData,
    toastConfig,
    setToastConfig,
    setcopy
  ) {
    setLoading(true);
    await axios
      .put(
        `${process.env.REACT_APP_API_URL}/api/v1/app/${viewData?.id}`,
        body,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((val) => {
        setLoading(false);
        if (val?.data?.success) {
          setsuccess(true);
          setauthData({
            client_id: val?.data?.result?.client_id,
            client_secret: val?.data?.result?.client_secret,
          });
          setcopy(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        if (
          err?.response?.statusText === "Unauthorized" ||
          err?.response?.status === "401"
        ) {
          localStorage.clear();
          window.location.reload();
        }
        if (!err.response) {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "error",
            message: "Network Error!",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              type: "error",
              message: "Network Error!",
            });
          }, 1800);
        }
      });
  }

  async Regenerate(
    setLoading,
    viewData,
    setauthData,
    toastConfig,
    setToastConfig,
    setReGeneratePopupShow,
    SetcopY
  ) {
    setLoading(true);
    await axios
      .put(
        `${process.env.REACT_APP_API_URL}/api/v1/app/auth/${viewData?.id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((val) => {
        setLoading(false);
        if (val?.data?.success) {
          setauthData({
            client_id: val?.data?.result?.client_id,
            client_secret: val?.data?.result?.client_secret,
          });
          setReGeneratePopupShow(false);
          SetcopY(true);
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "success",
            message: "Successfully Regenerate!",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              type: "success",
              message: "Successfully Regenerate!",
            });
          }, 1800);
        }
      })
      .catch((err) => {
        setLoading(false);
        if (
          err?.response?.statusText === "Unauthorized" ||
          err?.response?.status === "401"
        ) {
          localStorage.clear();
          window.location.reload();
        }
        if (!err.response) {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "error",
            message: "Network Error!",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              type: "error",
              message: "Network Error!",
            });
          }, 1800);
        }
      });
  }
}
